import { MenuItemKey, MenuItemProps, MenuItemVisibility } from "./MenuItem"
import { UserRole } from "@/types/user"

export const menuRoutes: MenuItemProps[] = [
   {
      key: MenuItemKey.TENANT_ADMIN,
      route: "CONTROL_PANEL",
      label: "Tenant Admin",
      icon: "tenantAdmin",
      visibility: MenuItemVisibility.CUSTOM,
   },
   {
      key: MenuItemKey.FLOOR_OVERVIEW,
      route: "FLOOR_OVERVIEW",
      label: "Floor Overview",
      icon: "floor",
      roles: [UserRole.ADMIN, UserRole.GUARD, UserRole.MANAGEMENT],
   },
   {
      key: MenuItemKey.WEARABLES_OVERVIEW,
      route: "WEARABLES_OVERVIEW",
      label: "ReassureBand Overview",
      icon: "smartwatch",
      roles: [UserRole.ADMIN, UserRole.GUARD, UserRole.MANAGEMENT],
   },
   {
      key: MenuItemKey.DEMO,
      route: "DEMO",
      label: "Demo",
      icon: "recalibrate",
      visibility: MenuItemVisibility.CUSTOM,
   },
   {
      key: MenuItemKey.SETTINGS,
      route: "SETTINGS",
      label: "Settings",
      icon: "settings",
      roles: [UserRole.ADMIN],
   },
   {
      key: MenuItemKey.PREFERENCES,
      route: "PREFERENCES",
      label: "Preferences",
      icon: "preferences",
      roles: [UserRole.ADMIN, UserRole.GUARD, UserRole.MANAGEMENT],
   },
   {
      key: MenuItemKey.LOGOUT,
      label: "Logout",
      icon: "logoff",
      roles: [UserRole.ADMIN, UserRole.GUARD, UserRole.MANAGEMENT],
   },
]
